var map = {
	"./i-accounting.svg": 70809,
	"./i-active-protection.svg": 11188,
	"./i-advantage1.svg": 70246,
	"./i-advantage2.svg": 92677,
	"./i-advantage3.svg": 41508,
	"./i-advantage4.svg": 29835,
	"./i-advantage5.svg": 15226,
	"./i-alfa-logo-min.svg": 80473,
	"./i-alpha-invest.svg": 12928,
	"./i-alternative-fz.svg": 6008,
	"./i-analytic-services-01.svg": 84964,
	"./i-analytic-services-02.svg": 28087,
	"./i-analytic-services-03.svg": 40550,
	"./i-analytic-services-04.svg": 43145,
	"./i-analytic-services-05.svg": 8280,
	"./i-analytic-services-06.svg": 47115,
	"./i-answer.svg": 37612,
	"./i-arrow-accordion.svg": 92676,
	"./i-arrow-accordion1.svg": 12669,
	"./i-arrow-back.svg": 47559,
	"./i-arrow-left.svg": 97721,
	"./i-arrow-right-accordion.svg": 83977,
	"./i-arrow-right-cart.svg": 83047,
	"./i-arrow-right-new.svg": 66617,
	"./i-arrow-right-white.svg": 27716,
	"./i-arrow-right.svg": 46788,
	"./i-arrow-right2.svg": 68318,
	"./i-arrow-right3.svg": 88367,
	"./i-arrow-right4.svg": 94576,
	"./i-arrow-right5.svg": 85697,
	"./i-arrow-up.svg": 77473,
	"./i-arrow-white.svg": 89945,
	"./i-arrow.svg": 79941,
	"./i-aton.svg": 51126,
	"./i-bank.svg": 76908,
	"./i-banner-pif.svg": 16018,
	"./i-bar-chart.svg": 29042,
	"./i-bear.svg": 23136,
	"./i-bell.svg": 2133,
	"./i-bks.svg": 35466,
	"./i-book-open.svg": 53362,
	"./i-book.svg": 43565,
	"./i-bpif-about-1.svg": 13391,
	"./i-bpif-about-2.svg": 34364,
	"./i-bpif-advantage-1.svg": 1387,
	"./i-bpif-advantage-2.svg": 26968,
	"./i-bpif-advantage-3.svg": 52329,
	"./i-bpif-growthcost.svg": 10304,
	"./i-bpif-h.svg": 38518,
	"./i-bpif-text.svg": 9791,
	"./i-bpif-v.svg": 78176,
	"./i-briefcase.svg": 94666,
	"./i-broker-icon.svg": 49105,
	"./i-burger.svg": 98061,
	"./i-calendar.svg": 86732,
	"./i-calendar2.svg": 52374,
	"./i-calendar3.svg": 91911,
	"./i-car-02.svg": 17507,
	"./i-car.svg": 38340,
	"./i-card-recive.svg": 60113,
	"./i-cart-white.svg": 36352,
	"./i-cart.svg": 21904,
	"./i-cash-flow.svg": 78952,
	"./i-chart-histogram.svg": 51895,
	"./i-chart-pie.svg": 39507,
	"./i-chart.svg": 78282,
	"./i-check-new.svg": 77595,
	"./i-check.svg": 46070,
	"./i-checked.svg": 57577,
	"./i-checked2.svg": 21753,
	"./i-close.svg": 33490,
	"./i-close1.svg": 69151,
	"./i-close2.svg": 13804,
	"./i-compass.svg": 54226,
	"./i-cycle.svg": 82900,
	"./i-diploma.svg": 54840,
	"./i-download-button.svg": 30811,
	"./i-download.svg": 55542,
	"./i-dzen-black.svg": 96943,
	"./i-dzen-circle-dark.svg": 15127,
	"./i-dzen-circle.svg": 89134,
	"./i-dzen.svg": 25937,
	"./i-empty-flash.svg": 80468,
	"./i-empty.svg": 24717,
	"./i-enter.svg": 89724,
	"./i-excel-regular.svg": 97756,
	"./i-excel-solid.svg": 31285,
	"./i-facebook.svg": 42490,
	"./i-fb.svg": 40654,
	"./i-file-excel.svg": 27658,
	"./i-file-new.svg": 961,
	"./i-file-pdf-new.svg": 5335,
	"./i-file-pdf.svg": 93105,
	"./i-file-pie.svg": 89405,
	"./i-file.svg": 92716,
	"./i-finam.svg": 40691,
	"./i-find.svg": 9959,
	"./i-flag.svg": 44020,
	"./i-full-flash.svg": 78224,
	"./i-gid.svg": 98806,
	"./i-google.svg": 11931,
	"./i-graduation-cap.svg": 69581,
	"./i-h-menu.svg": 45954,
	"./i-how-work-zpif.svg": 44104,
	"./i-info-advantages-01.svg": 37111,
	"./i-info-advantages-02.svg": 10340,
	"./i-info-advantages-03.svg": 65061,
	"./i-info-advantages-04.svg": 53434,
	"./i-info.svg": 51246,
	"./i-instagram.svg": 99630,
	"./i-invest-collect.svg": 31564,
	"./i-ipo.svg": 96108,
	"./i-legal.svg": 89593,
	"./i-like.svg": 68443,
	"./i-link.svg": 86238,
	"./i-list.svg": 3010,
	"./i-lk-nav-input-client.svg": 16934,
	"./i-lk-nav-open.svg": 71414,
	"./i-lk-nav-rt-red.svg": 59934,
	"./i-lk-nav-rt-white.svg": 45836,
	"./i-lock.svg": 85215,
	"./i-login-client.svg": 66847,
	"./i-logo-black.svg": 96385,
	"./i-logo-clean-new.svg": 81062,
	"./i-logo-clean.svg": 26563,
	"./i-logo-kids.svg": 5759,
	"./i-logo-new.svg": 44906,
	"./i-logo-small.svg": 23637,
	"./i-logo-white.svg": 40567,
	"./i-logo.svg": 76119,
	"./i-love.svg": 80366,
	"./i-mailru.svg": 65756,
	"./i-main-advantages-01.svg": 20400,
	"./i-main-advantages-02.svg": 77443,
	"./i-main-advantages-03.svg": 62802,
	"./i-main-advantages-04.svg": 96733,
	"./i-main-investments-01.svg": 10504,
	"./i-main-investments-02.svg": 91867,
	"./i-main-investments-03.svg": 66250,
	"./i-menu-capital.svg": 5600,
	"./i-menu-control.svg": 35839,
	"./i-menu-media.svg": 50980,
	"./i-menu-phone.svg": 5212,
	"./i-menu-pifs.svg": 98780,
	"./i-menu-research.svg": 29039,
	"./i-menu-services.svg": 46784,
	"./i-menu-solutions.svg": 12420,
	"./i-menu-stock.svg": 45242,
	"./i-menu.svg": 38887,
	"./i-message.svg": 73739,
	"./i-modal-success.svg": 97655,
	"./i-money-pie-graphic.svg": 67708,
	"./i-news.svg": 97823,
	"./i-newspaper.svg": 51251,
	"./i-noun-culture.svg": 6351,
	"./i-noun-education.svg": 72523,
	"./i-noun-health.svg": 12873,
	"./i-noun-protect.svg": 79192,
	"./i-noun-science.svg": 34347,
	"./i-open-kids-lk.svg": 51622,
	"./i-open-lk.svg": 63720,
	"./i-opif-advantage-3.svg": 59154,
	"./i-paper.svg": 16044,
	"./i-percent.svg": 95609,
	"./i-personal.svg": 56934,
	"./i-phone.svg": 63142,
	"./i-pie-chart.svg": 60827,
	"./i-pif-cart.svg": 87486,
	"./i-presentation.svg": 50698,
	"./i-print.svg": 27559,
	"./i-profile-user-new.svg": 94030,
	"./i-profile-user.svg": 82379,
	"./i-project-management.svg": 51539,
	"./i-pyramid.svg": 53658,
	"./i-question-small.svg": 58804,
	"./i-question.svg": 86926,
	"./i-research-team.svg": 12693,
	"./i-rocket-icon.svg": 67728,
	"./i-ruble.svg": 67620,
	"./i-safe.svg": 26357,
	"./i-sber-logo-min.svg": 6203,
	"./i-sber-logo.svg": 17168,
	"./i-sber.svg": 12664,
	"./i-search-2.svg": 40727,
	"./i-search-3.svg": 51750,
	"./i-search-icon-bold.svg": 82104,
	"./i-search-icon.svg": 81272,
	"./i-search-new.svg": 26851,
	"./i-search.svg": 56478,
	"./i-service-about-min.svg": 70784,
	"./i-service-about.svg": 54243,
	"./i-service-analytics-min.svg": 74431,
	"./i-service-analytics.svg": 9964,
	"./i-service-blog-min.svg": 27731,
	"./i-service-blog.svg": 66184,
	"./i-service-bonds-min.svg": 20149,
	"./i-service-bonds.svg": 12054,
	"./i-service-dividents-min.svg": 62527,
	"./i-service-dividents.svg": 16940,
	"./i-service-indexes-min.svg": 66727,
	"./i-service-indexes.svg": 83764,
	"./i-service-research-min.svg": 88432,
	"./i-service-research.svg": 88691,
	"./i-service-stock-min.svg": 33253,
	"./i-service-stock.svg": 13030,
	"./i-service-stockmap-min.svg": 68071,
	"./i-service-stockmap.svg": 80948,
	"./i-shield.svg": 78725,
	"./i-slider.svg": 31349,
	"./i-smi.svg": 38123,
	"./i-square.svg": 42995,
	"./i-tbank-logo-min.svg": 78615,
	"./i-tbank-logo.svg": 2372,
	"./i-tel.svg": 30929,
	"./i-telegram-icon.svg": 94539,
	"./i-tg-circle-dark.svg": 91763,
	"./i-tg-circle.svg": 59522,
	"./i-time.svg": 99305,
	"./i-trash.svg": 95152,
	"./i-triangle-black.svg": 19788,
	"./i-triangle-grey.svg": 72074,
	"./i-triangle-red.svg": 86436,
	"./i-triangle.svg": 37438,
	"./i-tw-circle.svg": 88722,
	"./i-tw.svg": 38437,
	"./i-view-matrix.svg": 55029,
	"./i-view-tabular.svg": 60521,
	"./i-view.svg": 54081,
	"./i-vk-circle-dark.svg": 81593,
	"./i-vk-circle.svg": 7748,
	"./i-vk.svg": 38311,
	"./i-vkontakte.svg": 45877,
	"./i-vtb-logo-min.svg": 71305,
	"./i-vtb-logo.svg": 84994,
	"./i-vtb.svg": 99938,
	"./i-wallet-white.svg": 34773,
	"./i-wallet.svg": 12545,
	"./i-work-time.svg": 81869,
	"./i-yandex.svg": 18629,
	"./i-yt-black.svg": 9219,
	"./i-yt-circle-dark.svg": 69107,
	"./i-yt-circle.svg": 74242,
	"./i-yt.svg": 48437,
	"./i-zero-tax.svg": 19400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32228;